import React, {Component} from 'react';
import ScrollContainer from "react-indiana-drag-scroll";
import Scrollspy from "react-scrollspy";
import {Nav} from "react-bootstrap";
import {PageLeftItem} from "../../model/page";
import "./components_navigation.scss";
import {LAST_COMPONENT_ID} from "../../config/api_config";
import {extraSmallLayout} from "../../utils/device";

export interface ComponentsNavigationData extends PageLeftItem {
    sections: string[];
}

class ComponentsNavigation extends Component<ComponentsNavigationData> {

    render() {
        const ids = this.props.sections.map(section => section.replace(/ /g, "-"));

        // mobile version
        if (extraSmallLayout()) {
            return (
                <div className="components-navigation" id="mobile-tabs" key="page-left-navigation">
                    <ScrollContainer horizontal={true} vertical={false}>
                        <Scrollspy items={ids} currentClassName="active-item"
                                   componentTag="div" style={{width: "max-content"}}>
                            {this.props.sections.map((section, index) => {
                                return (
                                    <Nav.Item key={`nav-${section}`}>
                                        <Nav.Link href={`#${index === this.props.sections.length - 1 ? LAST_COMPONENT_ID : ids[index]}`}
                                                  key={`link-${ids[index]}`}>{section.toUpperCase().substring(0, 12)}</Nav.Link>
                                    </Nav.Item>
                                );
                            })}
                        </Scrollspy>
                    </ScrollContainer>
                </div>
            )
        }

        // desktop version
        return (
            <div className="components-navigation">
                <Scrollspy key="page-left-navigation" items={ids} currentClassName="active-item" offset={64}>
                    {this.props.sections.map((section, index) => {
                        return (
                            <li key={`nav-${ids[index]}`}>
                                <a href={`#${index === this.props.sections.length - 1 ? LAST_COMPONENT_ID : ids[index]}`}
                                   key={`link-${ids[index]}`}>
                                    {section.toUpperCase()}
                                </a>
                            </li>
                        );
                    })}
                </Scrollspy>
            </div>
        );
    }
}

export default ComponentsNavigation;